import { computed, type Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useMetadataExperienceApi } from "@/composables/useMetadataExperienceApi";

export const EXPERIENCE_ADDITIONAL_SERVICES_QUERY_KEY = "experience-additional-services";

export function useExperienceAdditionalServicesQuery(experienceId: Ref<string>) {
  const { getAdditionalServices } = useMetadataExperienceApi();

  return useQuery({
    queryKey: [EXPERIENCE_ADDITIONAL_SERVICES_QUERY_KEY, experienceId],
    queryFn: () => getAdditionalServices(experienceId.value),
    select: ({ data }) => data,
    enabled: computed(() => !!experienceId.value),
  });
}
